import React, { Component, Children, ReactNode } from "react";

/**
 * Switch component for React
 *
 * Switch parameters:
 * condition: is condition for choice children component this may be a function call with the value of the case
 *
 * Case parameters:
 * value {String} match condition
 *
 * Example:
 *     <SwitchComponent condition={1}>
 *         <CaseComponent value={1}>
 *             <Text>This is one</Text>
 *         </CaseComponent>
 *         <CaseComponent value={2}>
 *             <Text>This is two</Text>
 *         </CaseComponent>
 *         <CaseComponent value={2}>
 *             <Text>This is also two</Text>
 *         </CaseComponent>
 *     </SwitchComponent>
 * */

interface SwitchComponentProps extends React.PropsWithChildren {
    condition?:
        | null
        | string
        | number
        | boolean
        | ((value: null | string | number | boolean) => boolean);
}

interface CaseComponentProps extends React.PropsWithChildren {
    value?: string | number | boolean | null;
}

class CaseComponent extends Component<CaseComponentProps> {
    render() {
        return this.props.children;
    }
}

class SwitchComponent extends Component<SwitchComponentProps> {
    getChildren() {
        const cases: ReactNode[] = [];
        Children.forEach(this.props.children, (item) => {
            if (!item) {
                return;
            }
            if (React.isValidElement(item) && item.type === CaseComponent) {
                const itemValue: string | number | boolean | null | undefined = (
                    item as React.ReactElement<CaseComponentProps>
                ).props.value;
                if (itemValue === null || itemValue === undefined) {
                    return;
                }
                if (typeof this.props.condition === "function") {
                    if (this.props.condition(itemValue)) {
                        cases.push(item);
                    }
                } else if (this.props.condition === itemValue) {
                    cases.push(item);
                }
            }
        });

        if (cases.length > 0) {
            return cases;
        }

        return null;
    }

    render() {
        const children = this.getChildren();
        return children?.length === 0 ? null : children;
    }
}

export { CaseComponent, SwitchComponent };
